/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TagEnum,
    TagEnumFromJSON,
    TagEnumFromJSONTyped,
    TagEnumToJSON,
} from './TagEnum';

/**
 * 
 * @export
 * @interface NumberOfDevicesPerTagItem
 */
export interface NumberOfDevicesPerTagItem {
    /**
     * 
     * @type {TagEnum}
     * @memberof NumberOfDevicesPerTagItem
     */
    tag?: TagEnum;
    /**
     * 
     * @type {number}
     * @memberof NumberOfDevicesPerTagItem
     */
    number?: number;
}

export function NumberOfDevicesPerTagItemFromJSON(json: any): NumberOfDevicesPerTagItem {
    return NumberOfDevicesPerTagItemFromJSONTyped(json, false);
}

export function NumberOfDevicesPerTagItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumberOfDevicesPerTagItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tag': !exists(json, 'tag') ? undefined : TagEnumFromJSON(json['tag']),
        'number': !exists(json, 'number') ? undefined : json['number'],
    };
}

export function NumberOfDevicesPerTagItemToJSON(value?: NumberOfDevicesPerTagItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tag': TagEnumToJSON(value.tag),
        'number': value.number,
    };
}

